import transportation from './transportation'
import babyRoom from './babyRoom'
import feeding from './feeding'
import home from './home'
import miscellaneous from './miscellaneous'

export default [
  transportation,
  babyRoom,
  feeding,
  home,
  miscellaneous,
]
